<script lang="ts">
    export let small: string;
    export let big: string;
    export let centerText = false;
</script>

<div class="uppercase tracking-widest flex flex-col gap-1.5 {centerText ? 'text-center' : ''}">
    <h2 class="text-primary font-medium
        text-[0.75rem]
        sm:text-[0.8125rem]
        md:text-[0.875rem]
        lg:text-[0.9375rem]
    ">
        {small}
    </h2>
    <h1 class="font-cinzel leading-[1.17em]
        text-[2.5rem]
        sm:text-[2.625rem]
        md:text-[2.75rem]
        lg:text-[2.875rem]
    ">
    {big}
    </h1>
</div>
